import { render, staticRenderFns } from "./Ppbprov.vue?vue&type=template&id=ec601196"
import script from "./Ppbprov.vue?vue&type=script&lang=js"
export * from "./Ppbprov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports